import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TabMotivos({ value, setValue }) {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Tab para elegir el filtrado de la tabla"
          centered
        >
          <Tab label="candidatos ocultos" {...a11yProps(3)} />
          <Tab
            label="candidatos que rechazaron la propuesta"
            {...a11yProps(0)}
          />
          <Tab label="Candidatos pendientes" {...a11yProps(1)} />
          <Tab label="Candidatos seleccionados" {...a11yProps(2)} />
        </Tabs>
      </Box>
    </Box>
  );
}
